import { DialogComponent } from '@theme/dialog';
import { CartAddEvent, CartOpenEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.#checkUrlForCartDrawer();
  }

  #checkUrlForCartDrawer() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cart-drawer') === 'open') {
      // Small delay to ensure DOM is ready
      requestAnimationFrame(() => {
        this.open();
        // Clean up the URL parameter without triggering a page reload
        const url = new URL(window.location.href);
        url.searchParams.delete('cart-drawer');
        window.history.replaceState({}, '', url.pathname + url.search);
      });
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });

    document.dispatchEvent(new CartOpenEvent())
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
